import { filters } from "@/filters";
import { $filters, setSoldOnMax, setSoldOnMin } from "@/stores/filters";
import { useStore } from "@nanostores/react";
import dayjs from "dayjs";
import { useCallback } from "react";
import { tw } from "tw-lite";
import { BarChart } from "./BarChart";
import data from "./data.json" with { type: "json" };
import { useRangeHandles } from "./useRangeHandle";

const scale: [number, number] = [new Date(data[0].week).getTime(), new Date(data[data.length - 1].week).getTime()];

const Label = tw(
  "label"
)`text-xs text-center top-10 text-slate-700 bg-slate-100 rounded-sm px-1`;

export function DateRangeNavigator() {
  const {
    soldOn: { min, max },
  } = useStore($filters);

  const setMin = useCallback(
    (value: number) => setSoldOnMin(new Date(value)),
    [filters]
  );
  const setMax = useCallback(
    (value: number) => setSoldOnMax(new Date(value)),
    [filters]
  );

  const { minRef, maxRef, areaRef } = useRangeHandles({
    setMin,
    setMax,
    scale,
  });

  return (
    <div className="fixed w-[40vw] z-10 bottom-10 left-1/2 -translate-x-1/2 h-12 bg-slate-100 rounded-sm">
      <BarChart className="w-full h-full absolute inset-0 z-0"/>
      <div
        ref={minRef}
        className="-left-1.5 top-3 absolute cursor-col-resize h-6 w-3 bg-slate-400 border border-slate-700 z-20"
      />
      <div
        ref={areaRef}
        className="top-1.5 absolute w-full h-9 border border-slate-500 rounded z-10"
      />
      <div
        ref={maxRef}
        className="-right-1.5 top-3 absolute cursor-col-resize h-6 w-3 bg-slate-400 border border-slate-700 z-20"
      />
      <Label className="absolute left-0">{dayjs(min)?.format("YYYY-MM-DD")}</Label>
      <Label className="absolute right-0">{dayjs(max)?.format("YYYY-MM-DD")}</Label>
    </div>
  );
}
